const styles = (theme) => ({
    formControlLabel: {
        margin: '20px 0px'
    }
});

export default styles;
